import { Modal } from '@/components/Modal';

import { StyledImageGallery } from './styles';

import type { RichContent } from '@/types/content';

interface ActivityMediaModalProps {
  showModal: boolean;
  closeModal: () => void;
  media: RichContent[];
}

function ActivityMediaModal({ showModal, closeModal, media }: ActivityMediaModalProps) {
  return (
    <Modal show={showModal} onClose={closeModal}>
      <StyledImageGallery>
        {media.map(
          (content, index) =>
            content.type.toLowerCase() === 'image' && (
              <img key={content.id} src={content.path} alt={`activity media ${index}`} />
            ),
        )}
      </StyledImageGallery>
    </Modal>
  );
}

export { ActivityMediaModal };
